export default "declare var global: typeof globalThis;\n";